(() => {
  const comparisonKey = 'selectCaravansComparisonV2';
  const filterKey = 'selectCaravansFiltersV2';
  const readStorage = (storage, key, fallback) => {
    try { return JSON.parse(storage.getItem(key)) || fallback; } catch (_) { return fallback; }
  };
  const read = (key, fallback) => readStorage(sessionStorage, key, fallback);
  const write = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
  const writeSelections = (value) => {
    try { localStorage.setItem(comparisonKey, JSON.stringify(value)); }
    catch (_) { write(comparisonKey, value); }
  };
  const getSelections = () => {
    const persistent = readStorage(localStorage, comparisonKey, null);
    if (Array.isArray(persistent)) return persistent;
    const legacy = read(comparisonKey, []);
    if (legacy.length) writeSelections(legacy);
    return legacy;
  };
  const clearSelections = () => {
    try { localStorage.removeItem(comparisonKey); } catch (_) {}
    sessionStorage.removeItem(comparisonKey);
  };
  const track = (eventName, detail = {}) => {
    const payload = { event: `select_showroom_${eventName}`, ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      const published = window.Shopify?.analytics?.publish?.(payload.event, detail);
      if (published && typeof published.catch === 'function') published.catch(() => {});
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('select:showroom', { detail: payload }));
  };

  function productData(button) {
    const scope = button.closest('[data-showroom-card], [data-showroom-root]') || document;
    const node = scope.querySelector('[data-card-product], [data-showroom-product]') || document.querySelector('[data-showroom-product]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  function updateCompareControls() {
    const selections = getSelections();
    document.querySelectorAll('[data-compare-count]').forEach((node) => { node.textContent = selections.length; });
    document.querySelectorAll('[data-compare-model-label]').forEach((node) => { node.textContent = selections.length === 1 ? 'model' : 'models'; });
    document.querySelectorAll('[data-compare-link]').forEach((node) => { node.hidden = selections.length === 0; });
    document.querySelectorAll('[data-compare-add]').forEach((button) => {
      const selected = selections.some((entry) => entry.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = selected ? 'Remove from comparison' : (button.closest('[data-showroom-card]') ? 'Compare' : 'Add to comparison');
    });
  }

  function normalisePreviewRoutes() {
    const view = new URLSearchParams(window.location.search).get('view');
    if (view === 'caravan-showroom-v2') {
      document.querySelectorAll('[data-compare-link], [data-compare-review]').forEach((link) => {
        link.href = '/pages/current-stock?view=caravan-compare-v2';
      });
    }
    if (view === 'caravan-compare-v2') {
      document.querySelectorAll('[data-showroom-return]').forEach((link) => {
        link.href = '/pages/current-stock?view=caravan-showroom-v2';
      });
    }
  }

  function bindCompareButtons() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-compare-add]');
      if (!button) return;
      const data = productData(button);
      if (!data) return;
      const selections = getSelections();
      const existing = selections.findIndex((entry) => entry.handle === data.handle);
      if (existing >= 0) {
        selections.splice(existing, 1);
        track('comparison_remove', { product_handle: data.handle });
      }
      else if (selections.length < 3) {
        selections.push(data);
        track('comparison_add', { product_handle: data.handle, comparison_count: selections.length });
      }
      else {
        track('comparison_limit', { product_handle: data.handle, comparison_count: selections.length });
        window.alert('You can compare up to three caravans. Select “Review and remove caravans” to remove one before adding another.');
        return;
      }
      writeSelections(selections);
      updateCompareControls();
    });
  }

  function bindGallery() {
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      const counter = gallery.querySelector('[data-gallery-count]');
      const dialogCounter = gallery.querySelector('[data-gallery-dialog-count]');
      let dialogIndex = 0;
      const activate = (index) => {
        const normalized = (Number(index) + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const active = position === normalized;
          slide.classList.toggle('is-active', active);
          if (active) {
            const image = slide.querySelector('img[data-gallery-src]');
            if (image) {
              image.src = image.dataset.gallerySrc;
              image.srcset = image.dataset.gallerySrcset;
              delete image.dataset.gallerySrc;
              delete image.dataset.gallerySrcset;
            }
          }
        });
        thumbs.forEach((thumb, position) => thumb.classList.toggle('is-active', position === normalized));
        if (counter) counter.textContent = `${normalized + 1} / ${slides.length}`;
        return normalized;
      };
      const showDialogImage = (index) => {
        dialogIndex = activate(index);
        const source = slides[dialogIndex]?.querySelector('img');
        if (!source || !dialogImage) return;
        dialogImage.src = source.currentSrc || source.src;
        dialogImage.alt = source.alt;
        if (dialogCounter) dialogCounter.textContent = `${dialogIndex + 1} / ${slides.length}`;
      };
      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) {
          activate(thumb.dataset.galleryThumb);
          return;
        }
        const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (event.target.closest('[data-gallery-prev]')) { activate(current - 1); return; }
        if (event.target.closest('[data-gallery-next]')) { activate(current + 1); return; }
        if (event.target.closest('[data-gallery-dialog-prev]')) { showDialogImage(dialogIndex - 1); return; }
        if (event.target.closest('[data-gallery-dialog-next]')) { showDialogImage(dialogIndex + 1); return; }
        const opener = event.target.closest('[data-gallery-open]');
        if (opener && dialog && dialogImage) {
          showDialogImage(Number(opener.dataset.gallerySlide));
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          track('gallery_fullscreen', { image_index: Number(opener.dataset.gallerySlide) + 1 });
        }
        if (event.target.closest('[data-gallery-close]') && dialog) dialog.close();
      });
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showDialogImage(dialogIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showDialogImage(dialogIndex + 1); }
      });
    });
  }

  function bindJourneyTracking() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-showroom-event]');
      if (!link) return;
      const product = document.querySelector('[data-showroom-product]');
      let handle = '';
      try { handle = product ? JSON.parse(product.textContent).handle : ''; } catch (_) {}
      track(link.dataset.showroomEvent, { product_handle: handle, destination: link.getAttribute('href') });
    });
  }

  function bindFilters() {
    const root = document.querySelector('[data-showroom-index]');
    if (!root) return;
    const form = root.querySelector('[data-showroom-filters]');
    const grid = root.querySelector('[data-card-grid]');
    const cards = [...root.querySelectorAll('[data-showroom-card]')];
    const count = root.querySelector('[data-result-count]');
    const noResults = root.querySelector('[data-no-results]');
    const saved = read(filterKey, {});
    Object.entries(saved).forEach(([name, value]) => { if (form.elements[name]) form.elements[name].value = value; });

    const values = () => Object.fromEntries(new FormData(form).entries());
    const number = (value) => value === '' ? null : Number(value);
    const apply = () => {
      const state = values();
      write(filterKey, state);
      let visible = 0;
      cards.forEach((card) => {
        const show = (!state.status || card.dataset.status === state.status)
          && (!state.brand || card.dataset.brand === state.brand)
          && (!state.buyer || card.dataset.buyer.includes(state.buyer))
          && (!number(state.berths) || Number(card.dataset.berths) >= number(state.berths))
          && (!state.terrain || card.dataset.terrain === state.terrain)
          && (!number(state.weight) || (Number(card.dataset.weight) > 0 && Number(card.dataset.weight) <= number(state.weight)))
          && (!number(state.length) || (Number(card.dataset.length) > 0 && Number(card.dataset.length) <= number(state.length)))
          && (!number(state.price) || (Number(card.dataset.price) > 0 && Number(card.dataset.price) <= number(state.price) * 100));
        card.hidden = !show;
        if (show) visible += 1;
      });
      const sorters = {
        featured: (a, b) => Number(a.dataset.rank) - Number(b.dataset.rank),
        'price-asc': (a, b) => Number(a.dataset.price) - Number(b.dataset.price),
        'price-desc': (a, b) => Number(b.dataset.price) - Number(a.dataset.price),
        'weight-asc': (a, b) => (Number(a.dataset.weight) || Infinity) - (Number(b.dataset.weight) || Infinity)
      };
      cards.sort(sorters[state.sort] || sorters.featured).forEach((card) => grid.appendChild(card));
      count.textContent = `${visible} ${visible === 1 ? 'caravan' : 'caravans'}`;
      noResults.hidden = visible !== 0;
    };
    form.addEventListener('input', apply);
    form.addEventListener('reset', () => { sessionStorage.removeItem(filterKey); setTimeout(apply, 0); });
    root.querySelector('[data-filter-reset]')?.addEventListener('click', () => form.reset());
    apply();
  }

  function comparisonCell(value, extraClass = '') {
    const cell = document.createElement('td');
    cell.className = extraClass;
    cell.textContent = value === null || value === undefined || value === '' ? 'Not specified' : value;
    return cell;
  }

  function renderComparison() {
    const root = document.querySelector('[data-showroom-compare]');
    if (!root) return;
    const selections = getSelections().slice(0, 3);
    const empty = root.querySelector('[data-compare-empty]');
    const content = root.querySelector('[data-compare-content]');
    const legend = root.querySelector('[data-compare-content-legend]');
    const actions = root.querySelector('[data-compare-actions]');
    empty.hidden = selections.length > 0;
    content.hidden = selections.length === 0;
    if (legend) legend.hidden = selections.length === 0;
    actions.hidden = selections.length === 0;
    if (!selections.length) return;

    const body = root.querySelector('[data-compare-body]');
    const table = body.closest('table');
    table.querySelector('colgroup')?.remove();
    const columnGroup = document.createElement('colgroup');
    const labelColumn = document.createElement('col');
    labelColumn.className = 'scv2-compare-label-column';
    columnGroup.appendChild(labelColumn);
    selections.forEach(() => columnGroup.appendChild(document.createElement('col')));
    table.insertBefore(columnGroup, body);
    body.replaceChildren();
    const head = document.createElement('tr');
    const label = document.createElement('th');
    label.scope = 'row'; label.textContent = 'Model'; head.appendChild(label);
    selections.forEach((item) => {
      const cell = document.createElement('td');
      const image = document.createElement('img'); image.src = item.image; image.alt = '';
      const imageLink = document.createElement('a'); imageLink.href = item.url; imageLink.className = 'scv2-compare-image-link'; imageLink.setAttribute('aria-label', `View ${item.title}`); imageLink.appendChild(image);
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove from comparison'; remove.dataset.compareRemove = item.handle;
      cell.append(imageLink, link, remove); head.appendChild(cell);
    });
    body.appendChild(head);

    const rows = [['Price','price'],['Availability','status'],['Brand','brand'],['Berths','berths'],['Layout','layout'],['Terrain','terrain'],['Tare','tare'],['ATM','atm'],['Overall length','length'],['Solar','solar'],['Battery','battery']];
    rows.forEach(([title, key]) => {
      const row = document.createElement('tr');
      const heading = document.createElement('th'); heading.scope = 'row'; heading.textContent = title; row.appendChild(heading);
      const displayed = selections.map((item) => item[key] || 'Not specified');
      const differs = new Set(displayed).size > 1;
      displayed.forEach((value) => row.appendChild(comparisonCell(value, differs ? 'is-different' : '')));
      body.appendChild(row);
    });

  }

  function bindComparison() {
    const root = document.querySelector('[data-showroom-compare]');
    if (!root) return;
    root.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-compare-remove]');
      if (remove) {
        writeSelections(getSelections().filter((item) => item.handle !== remove.dataset.compareRemove));
        track('comparison_remove', { product_handle: remove.dataset.compareRemove });
        renderComparison(); updateCompareControls();
      }
      if (event.target.closest('[data-compare-clear]')) {
        clearSelections(); track('comparison_clear'); renderComparison(); updateCompareControls();
      }
    });
    renderComparison();
  }

  document.addEventListener('DOMContentLoaded', () => {
    normalisePreviewRoutes(); bindCompareButtons(); bindGallery(); bindJourneyTracking(); bindFilters(); bindComparison(); updateCompareControls();
  });
})();

